import { render, staticRenderFns } from "./DetailPrescribedDrugsRep.vue?vue&type=template&id=22252c1e&"
import script from "./DetailPrescribedDrugsRep.vue?vue&type=script&lang=js&"
export * from "./DetailPrescribedDrugsRep.vue?vue&type=script&lang=js&"
import style0 from "./DetailPrescribedDrugsRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports